import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ec5525",
      hover: "#ef7048",
      focus: "#f17e59",
      active: "#ec5525",
    },
    secondary: {
      main: "#0a859a",
      hover: "#3199aa",
      focus: "#45a2b2",
      active: "#0a859a",
    },
    purple: {
      main: "#4e2ee6",
    },
    blue: {
      main: "#2b7efb",
    },
    yellow: {
      main: "#ff9c12",
    },
    error: {
      main: "#c73426",
    },
    success: {
      main: "#13c77a",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
    },
    green: {
      main: "#13C77A",
    },
    lightgreen: {
      main: "#8FDEB2",
    },
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
